module.exports = __webpack_public_path__ + "static/media/S2N10-3.98beaeac.svg";